import React, { useEffect } from "react";
import Highcharts from "highcharts";
// Import the highcharts venn module (side-effect import)
import "highcharts/modules/venn";

const VennDiagram = ({ fund1Name, fund2Name, overlapPercentage }) => {
  useEffect(() => {
    const chart = Highcharts.chart("venn-container", {
      chart: {
        type: "venn",
        backgroundColor: "transparent",
        height: 400,
      },
      title: {
        text: null,
      },
      tooltip: {
        enabled: false,
      },
      series: [
        {
          type: "venn",
          name: "Fund Overlap",
          data: [
            {
              sets: [fund1Name],
              value: 100,
              name: fund1Name,
              color: "#8FA882",
            },
            {
              sets: [fund2Name],
              value: 100,
              name: fund2Name,
              color: "#C9A882",
            },
            {
              sets: [fund1Name, fund2Name],
              value: overlapPercentage,
              name: `${overlapPercentage}%`,
              color: "#B8A882",
            },
          ],
          dataLabels: {
            style: {
              fontSize: "24px",
              fontWeight: "bold",
              textOutline: "none",
            },
          },
        },
      ],
      credits: {
        enabled: false,
      },
    });

    return () => {
      if (chart) {
        chart.destroy();
      }
    };
  }, [fund1Name, fund2Name, overlapPercentage]);

  return (
    <div>
      <div id="venn-container" style={{ width: "100%", height: "400px" }} />
      
      {/* Legend */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: 32,
          marginTop: 24,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div
            style={{
              width: 20,
              height: 20,
              borderRadius: "50%",
              backgroundColor: "#8FA882",
            }}
          />
          <span style={{ fontSize: 14, color: "#666" }}>{fund1Name}</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div
            style={{
              width: 20,
              height: 20,
              borderRadius: "50%",
              backgroundColor: "#C9A882",
            }}
          />
          <span style={{ fontSize: 14, color: "#666" }}>{fund2Name}</span>
        </div>
      </div>
    </div>
  );
};

export default VennDiagram;